<!-- <form [formGroup]="datesForm">
    <mat-form-field>
        <mtx-datetimepicker-toggle [for]="datetimePicker" matSuffix></mtx-datetimepicker-toggle>
        <input [mtxDatetimepicker]="datetimePicker" autocomplete="false" matInput required />
    </mat-form-field>
</form> -->

<form [formGroup]="datesForm">
  <div class="date-time-picker" [ngClass]="{ filled: datesForm.get('date')?.value }" (click)="picker.open()">
    <img class="date-time-picker-icon" src="assets/images/common/date.svg" alt="date" />
    <div *ngIf="!datesForm.get('date')?.value">
      <div class="date-time-picker-title">
        {{ label | labelsProvider }}
      </div>
    </div>
    <input matInput [mtxDatetimepicker]="picker" formControlName="date" [max]="maxDate || today" [min]="minDate" />
    <mtx-datetimepicker #picker [timeInterval]="1" type="datetime"></mtx-datetimepicker>
    <img src="assets/images/arrows/empty-arrow-down.svg" class="drop-down" alt="expand" />
    <div class="date-time-picker-with-dates" *ngIf="datesForm.get('date')?.value">
      <img
        class="date-time-picker-cancel"
        src="assets/images/common/cancel.svg"
        (click)="clearForm(); $event.stopPropagation()"
        alt="cancel"
      />
    </div>
  </div>
</form>
